module.exports = __webpack_public_path__ + "img/leaf-white.9b17d553.svg";